import { MdClose } from "react-icons/md";
import { Modal } from "react-bootstrap";
import { QRCode } from "react-qrcode-logo";
import { convertCurrency, numberFormat } from "../helper";

const bankLogos = [
  {
    id: 1,
    logo: "https://www.jdbbank.com.la/wp-content/uploads/2019/05/jdb-ico.png",
  },
  { id: 2, logo: "/assets/image/bcel-logo.png" },
  { id: 3, logo: "/assets/image/ib-logo.png" },
  {
    id: 4,
    logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSAaA92cPEkNBK2m4dBAwv-bCUVifRYzkRSzw&s",
  },
  {
    id: 5,
    logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTtWVw0jkJNbp-I6SlDFVkROXzxZPfDJU35FVLvMi8bObZuOZQ-3oHUcs7LsRfCxmyG59o&usqp=CAU",
  },
  { id: 5, logo: "/assets/image/Thai-qr.webp" },
  { id: 5, logo: "/assets/image/union-pay.png" },
];
const WaitingPaymentModal = ({
  show,
  onHide,
  paymentData,
  title,
  showClose,
  receivedMoney,
  viewCurrency
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      backdrop="static" // Prevents closing on outside click
      keyboard={false} // Prevents closing on Esc key press
    >
      <Modal.Body style={{ padding: 20 }}>
        <div
          style={{
            position: "relative",
            height: "40em",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          {/* Absolute close icon */}
          {/* <div className="d-flex justify-content-center">
            <h3 className="fw-bold"><b>{title ? title : "ລໍຖ້າລູກຄ້າສະເເກນຈ່າຍເງີນ"}</b></h3>
          </div> */}
          {/* <div className="w-100 d-flex align-items-center gap-3" style={{position:"absolute",top:"9px",left:"5px"}}>
            <img
              src="/assets/image/policy-logo.png"
              alt="Policy Logo"
              className="img-fluid"
              style={{ width: "40px", height: "40px" }}
            />
            <div style={{ marginTop: "1rem" }}>
              <p className="fw-medium" style={{ fontSize: "1.2rem" }}>
                ທຸລະກຳໄດ້ຮັບການກວດສອບຄວາມຖືກຕ້ອງ ແລະ ຄວາມປອດໄພສຳເລັດ
              </p>
            </div>
          </div> */}
          <div className="mt-2">
            <p className="fw-bold">{title ? title : "ລໍຖ້າລູກຄ້າສະເເກນຈ່າຍເງີນ..."}</p>
          </div>
          <h2><b>ຍອດເງິນ: {numberFormat(receivedMoney ?? 0)} {convertCurrency(viewCurrency)}</b></h2>
          <div
            className="qr-container"
            style={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <QRCode size={280} value={paymentData?.qrCode ?? ""} />
            <div
              className="icon-overlay"
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 10,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%",
              }}
            >
              <img
                src="https://lapnet.com.la/storage/products/January2023/RJIZBNdN4639D6wjTZBb.png" // Replace with the path to your image
                alt="Center Images" // Add appropriate alt text for accessibility
                style={{
                  maxWidth: "14%",
                  maxHeight: "14%",
                  background: "#fff",
                  padding: "5px",
                }}
              />
            </div>
          </div>
          <div className="w-70 mt-4 d-flex flex-column align-items-center justify-content-center">
            <h5>ຄວາມປອດໄພຂອງທ່ານຄືສິ່ງທີ່ເຮົາຄໍານຶງເຖິງອັນດັບທໍາອິດ.</h5>
            <h5>
              ຊໍາລະເງິນຢ່າງໝັ້ນໃຈ ແລະ
              ຂໍ້ມູນຂອງທ່ານຈະຖືກປົກປ້ອງສະເໝີດ້ວຍເທັກໂນໂລຊີຂັ້ນສູງ.
            </h5>
          </div>
          <div className="d-flex gap-4 mb-4 mt-4">
            {bankLogos?.map((bankLogo) => (
              <img
                key={bankLogo.id}
                src={bankLogo.logo}
                alt={bankLogo.id}
                className="img-fluid"
                style={{ width: "45px", height: "45px", objectFit: "cover" }}
              />
            ))}
          </div>
          {showClose && (
            <div
              onClick={onHide}
              style={{
                position: "absolute",
                top: "-0.8em",
                borderRadius: 20,
                border: "1px solid #ddd",
                cursor: "pointer",
                right: "-0.8em",
                padding: 5,
                background: "#fff",
              }}
            >
              <MdClose style={{ fontSize: 25, color: "red" }} />
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default WaitingPaymentModal;
